import React, { useState, useEffect, useRef } from "react";


const ButtonWrapper = ({ children, onOutsideClick }) => {
    const scrollRef = useRef(null);
    const scrollPosRef = useRef(0);
    
    const handleScroll = () => {
        if (scrollRef.current) {
            scrollPosRef.current = scrollRef.current.scrollTop;
        }
    };

    useEffect(() => {
        if (scrollRef.current && scrollPosRef.current > 0) {
            scrollRef.current.scrollTop = scrollPosRef.current;
        }
    });

    return (
        <div
            ref={scrollRef}
            className="h-full pt-1 overflow-y-auto bg-gray-100 gap-3 grid grid-cols-2 auto-rows-min" //sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 
            onScroll={handleScroll}
            onClick={onOutsideClick}
        >
            {children}
        </div>
    );
};

export default ButtonWrapper